import {Types} from 'mongoose';
import {SURVEY_AUDIENCE_TYPES} from './survey-audience-type.const';

/**
 * Represents the survey audience types.
 * @typedef {Object} SurveyAudienceType
 * @property {string} type - The type of the survey audience.
 * @property {string} category - The category of the survey audience.
 * @property {Array<{label: string, value: string, _id: Types.ObjectId}>} value - The array of survey audience values.
 */
export const SURVEY_AUDIENCE_TYPE = {
    type: 'Survey Audience Type',
    category: 'System',
    value: SURVEY_AUDIENCE_TYPES.map(i => ({...i, _id: new Types.ObjectId(i._id)})),
};
